import { FormData } from '../hooks';

export const getFormData = (whoami: Whoami): Partial<FormData> => ({
  name: whoami.user.name,
  role_category: whoami.user.role_category,
  job_title: whoami.user.job_title
});
